import React, { Component } from "react";
import { Link } from "react-router-dom";
import Gravatar from "react-gravatar";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import { store } from "../../_helpers";
import { userService } from "../../_services";
import "./index.css";

class MenuBar extends Component {
  componentWillMount() {
    const { email_md5, display_name, email, token } = this.props.user;
    if (!email_md5 && !display_name && !email && token) {
      store.dispatch(userService.getAuthenticatedUser(token));
    }
  }

  render() {
    const { email_md5, display_name, email } = this.props.user;

    let gravatarIcon;
    if (!email_md5) {
      gravatarIcon = <Gravatar md5={"undefined"} size={44} default="mp" className="gravatarIcon" />;
    } else {
      gravatarIcon = <Gravatar md5={email_md5} size={44} default="mp" className="gravatarIcon" />;
    }

    return (
      <div className="MenuBar clearfix">
        <div className="container">
          <Link to="/" title="dashboard">
            <div className="main-logo metrotunnel" alt="MetroTunnel Logo" />
            <div className="main-logo cyp" alt="Cross Yarra Partnership Logo" />
            <div className="main-logo victoria" alt="Victoria State Government Logo" />
          </Link>
          <div className="topMenu">
            <div className="header-txt pull-left">Metro Tunnel Environmental Monitor</div>
            {gravatarIcon}
            <div className="userContols">
              <div className="username">{display_name || email || email_md5}</div>
              <Link className="logout-link clearfix" to="/login" title="Logout">
                <FontAwesome name="sign-out-alt" className="logout-link-icon icon-color" />
                <span className="logout-link-text">Logout</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(MenuBar);



// WEBPACK FOOTER //
// ./src/_components/MenuBar/index.js